module.exports = __webpack_public_path__ + "media/images/samples/home/ep/ep1-1ff5f66406b783a17ae6df80f297385c.png";